import { render, staticRenderFns } from "./TabInsuranceHistory.vue?vue&type=template&id=459e9e86"
import script from "./TabInsuranceHistory.vue?vue&type=script&lang=js"
export * from "./TabInsuranceHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports